import { defineComponent as _defineComponent } from 'vue'
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {computed, ref} from "vue";
import {FOPLabelFormatData} from "@/models/NutritionLabels/FOPLabelFormatData";
import {SupportedPDS} from "@/models/NutritionLabels/SupportedPDS";
import {CanadaFOPHighInMetadata} from "@/models/NutritionLabels/CanadaFOPHighInMetadata";
import NutritionLabelRepository from "@/utils/API/NutritionLabelRepository";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {NutritionalFrontOfPackRenderData} from "@/models/NutritionLabels/ExportLabelState";

type CanadaFrontOfPackConfigurationProps = {
  language: string;
  hasCautionary: boolean;
  highIn: CanadaFOPHighInMetadata;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CanadaFrontOfPackConfiguration',
  props: {
    language: null,
    hasCautionary: { type: Boolean },
    highIn: null
  },
  emits: ["update:renderModel"],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  language: string;
  hasCautionary: boolean;
  highIn: CanadaFOPHighInMetadata;
};




const translations = useTranslations();

const selectedFormat = ref<FOPLabelFormatData>({
  formatValue: 1,
  language: LabelLanguage.English,
  supportedPDS: [],
  formatTranslationKey: ""
});
const selectedPDS = ref<SupportedPDS>({ translationKey: "", value: 1 });
const fopData = ref<NutritionalFrontOfPackRenderData>({
  fopFormat: 1,
  pdsSize: 1,
  includeInDownload: true
});
const pdsSizeOptions = ref<SupportedPDS[]>([]);
const labelFormatOptions = ref<FOPLabelFormatData[]>([]);

const renderModel = computed(() => {
  return {
    country: "Canada",
    labelName: "NutritionalFrontOfPack",
    renderModel: {
      format: selectedFormat.value.formatValue,
      pdsSize: selectedPDS.value.value,
      highIn: props.highIn
    }
  };
});

function loadLabelFormats() {
  // @ts-expect-error TEMP For Demo
  NutritionLabelRepository.getFrontOfPackageOptions(LabelLanguage[props.language]).then((response) => {
    labelFormatOptions.value = response.data;
    let savedFormat = labelFormatOptions.value.find(
      (x: any) => x.formatValue == fopData.value.fopFormat
    );

    updateFOPSelections(savedFormat || labelFormatOptions.value[0]);
  });
}

function updateFOPSelections(chosenFormat: FOPLabelFormatData){
  selectedFormat.value = chosenFormat;
  pdsSizeOptions.value = chosenFormat.supportedPDS;

  let selectedPDSFormat = pdsSizeOptions.value.find(
    (x: any) => x.value == fopData.value.pdsSize
  );

  if(selectedPDSFormat) {
    selectedPDS.value = selectedPDSFormat;
  }

  else {
    selectedPDS.value = pdsSizeOptions.value[0];
  }

  emit("update:renderModel");
}

function foPFormatReducer(fopData: FOPLabelFormatData) {
  return fopData.formatValue;
}

function foPPDSReducer(pdsData: SupportedPDS) {
  return pdsData.translationKey;
}

function fetchLabelFormats(chosenFormat: FOPLabelFormatData) {
  const selected = labelFormatOptions.value.find(
    (format) => format.formatValue === chosenFormat.formatValue
  );

  if (selected) {
    selectedFormat.value = selected;
    fopData.value.fopFormat = selected.formatValue;
    updatePDSSizes(selected.supportedPDS);
  }

  emit("update:renderModel");
}

function updatePDSSizes(supportedPDS: SupportedPDS[]) {
  pdsSizeOptions.value = supportedPDS;

  selectedPDS.value = pdsSizeOptions.value[0];
  fopData.value.pdsSize = selectedPDS.value.value;
}

expose({
  renderModel,
  loadLabelFormats
});

return { __sfc: true,props, emit, translations, selectedFormat, selectedPDS, fopData, pdsSizeOptions, labelFormatOptions, renderModel, loadLabelFormats, updateFOPSelections, foPFormatReducer, foPPDSReducer, fetchLabelFormats, updatePDSSizes, CollapsableCard }
}

})